import { Button } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React from 'react';
import { HOCLocalization } from '../../../utils/HOC/HOCLocalization';
import './Footer-Common.scss';
import { IFooterProps } from './IFooterProps';

const Footer = (props: IFooterProps) => {
  const [t, lng] = useTranslation();
  return (
    <div className="footer-container">
      <div className="back-step">
        {props.currentStep > 1 && (
          <Button
            size="small"
            type="inline-secondary"
            onClick={props.previousStep}
          >
            {t('back')}
          </Button>
        )}
      </div>
      <div className="cancel-save-button">
        <Button size="small" type="inline-secondary" onClick={props.onCancel}>
          {t('cancel')}
        </Button>
        {props.currentStep < props.totalSteps ? (
          <Button
            size="small"
            type="primary"
            disabled={props.isInValid}
            onClick={props.onNext}
          >
            {t('saveAndContinue')}
          </Button>
        ) : (
          <Button
            type="primary"
            size="small"
            disabled={props.isInValid}
            onClick={props.onSubmit}
          >
            {t('Finish')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default HOCLocalization(Footer);
